import getConfig from 'next/config';

export interface SocialMediaShareUrls {
  facebookShareUrl: string;
  whatsAppShareUrl: string;
  fbMessengerShareUrl: string;
  copyLinkUrl: string;
}
const { publicRuntimeConfig } = getConfig();

export const getSocialMediaShareURLs = (
  shareTargetUrl: URL,
  isMobile: boolean,
): SocialMediaShareUrls => {
  const facebookAppId = publicRuntimeConfig.FACEBOOK_MESSENGER_APP_ID;

  shareTargetUrl.searchParams.set(
    'utm_medium',
    isMobile ? 'mobile' : 'desktop',
  );

  shareTargetUrl.searchParams.set('utm_campaign', 'share');

  const generateFacebookShareUrl = (): string => {
    shareTargetUrl.searchParams.set('utm_source', 'facebook');

    const facebookShareUrl = new URL(
      'https://www.facebook.com/sharer/sharer.php',
    );

    facebookShareUrl.searchParams.set('u', shareTargetUrl.toString());
    return facebookShareUrl.toString();
  };

  const generateWhatsAppShareUrl = (): string => {
    shareTargetUrl.searchParams.set('utm_source', 'whatsapp');

    const whatsAppShareUrl = new URL(
      isMobile ? 'whatsapp://send' : 'https://api.whatsapp.com/send',
    );

    whatsAppShareUrl.searchParams.set('text', shareTargetUrl.toString());
    return whatsAppShareUrl.toString();
  };

  const generateFbMessengerShareUrl = (): string => {
    shareTargetUrl.searchParams.set('utm_source', 'messenger');

    const fbMessengershareUrl = new URL(
      isMobile ? `fb-messenger://share` : `https://www.messenger.com/new`,
    );

    fbMessengershareUrl.searchParams.set('app_id', facebookAppId);
    fbMessengershareUrl.searchParams.set('link', shareTargetUrl.toString());
    return fbMessengershareUrl.toString();
  };

  const generateCopyLinkUrl = (): string => {
    shareTargetUrl.searchParams.set('utm_source', 'copy_link');
    return shareTargetUrl.toString();
  };

  return {
    facebookShareUrl: generateFacebookShareUrl(),
    whatsAppShareUrl: generateWhatsAppShareUrl(),
    fbMessengerShareUrl: generateFbMessengerShareUrl(),
    copyLinkUrl: generateCopyLinkUrl(),
  };
};
